import { render, staticRenderFns } from "./LeadObject.vue?vue&type=template&id=6f47f223&scoped=true"
import script from "./LeadObject.vue?vue&type=script&lang=js"
export * from "./LeadObject.vue?vue&type=script&lang=js"
import style0 from "./LeadObject.vue?vue&type=style&index=0&id=6f47f223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f47f223",
  null
  
)

export default component.exports